


































































import { Component, Mixins, Prop, Provide } from 'vue-property-decorator'
import { DiscountsMixin } from '@shared/mixins/discounts'
import { toV } from '@/app/core/utils'
import { SuperMixin } from '../../category.mixin'
import { routerPush, toDemotion } from '@/app/core/utils'
import BusinessItem from '@pages/search/components/common/business_item.vue'

@Component({
  components: {
    BusinessItem,
  },
  filters: {
    distanceStr(distance: string) {
      return +distance > 60 ? '>60' : distance
    },
  },
})
export default class TentantComponent extends Mixins(SuperMixin, DiscountsMixin) {
  @Prop({ type: Boolean, default: false }) readonly showEntity!: boolean
  @Prop({ type: Boolean, default: false }) readonly showEmpty!: boolean
  @Prop({ type: Array, default: [] }) readonly list!: any[]

  @Provide()
  pageTrackParams: any = {}
  @Provide()
  clickid_200001 = ''
  @Provide()
  clickid_200003 = ''
  @Provide()
  clickid_200002 = ''

  // toShop(item: any) {
  //   const { businessId } = item
  //   routerPush({ name: 'shop', query: { businessId } })
  // }
  // hasDiscounts(item: any) {
  //   const coupon = this.seekCoupon(item)
  //   const promotion = this.seekPromotion(item)
  //   const seckill = promotion?.seckill

  //   const nextText = item.minPrice != item.maxPrice ? '起' : ''
  //   const seckillText = seckill ? `秒杀¥${toDemotion(seckill.promotionPrice)}${nextText}` : undefined
  //   return seckillText || promotion?.subtract?.promotionName || coupon?.couponName
  // }

  // groupAndPresent(item: any) {
  //   const { group, present } = this.seekPromotion(item)
  //   return { group, present }
  // }

  // toDetail(item: any) {
  //   const { spuId, businessId } = item
  //   // const { seckill } = this.seekPromotion(item)
  //   //const query: any = seckill ? { skuId: seckill.skuId, ruleId: seckill.ruleId, ruleType: 3 } : {}
  //   toV({
  //     name: 'product-detail',
  //     params: { spuId },
  //     query: { refresh: 'no', businessId },
  //   })
  // }
}
